module.exports = "label {\n    color: rgb(31, 112, 191)\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/reset-password/reset-password.component.css
// module id = ./src/app/reset-password/reset-password.component.css
// module chunks = main